import { validate } from "com";
import { USER_ENDPOINTS } from "./endpoints";
import { apiPost, sanitizeEmail } from "../shared";
import { RequestPasswordResetPayload, RequestPasswordResetResponse } from "./types";

export default async function requestPasswordReset(email: string): Promise<RequestPasswordResetResponse> {
  const sanitizedEmail = sanitizeEmail(email);
  validate.email(sanitizedEmail);

  const payload: RequestPasswordResetPayload = { email: sanitizedEmail };
  return await apiPost<RequestPasswordResetResponse>(USER_ENDPOINTS.FORGOT_PASSWORD, payload);
}
